// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const radioClasses = {
  group: "qui-radio-group__root",
  groupLabel: "qui-radio-group__label",
  item: "qui-radio__root",
  itemControl: "qui-radio__control",
  itemHiddenInput: "qui-radio__hidden-input",
  itemLabel: "qui-radio__label",
  items: "qui-radio-group__items",
} as const
